<template>
	<div id="global-login-form">
		<modal id="global-login-modal">
	        <div class="modal-container" slot="modal-container">
	            <h2>{{$t('modal.time-expired.headline')}}</h2>
	            <input type="text" :placeholder="$t('login.form.email')" v-model="email" v-on:keyup.enter="login()" />
	            <input type="password" :placeholder="$t('login.form.password')" v-model="password" v-on:keyup.enter="login()" />
				<div v-if="showErrors">
					<ul v-for="error in showErrors">
						<li>{{error}}</li>
					</ul>
				</div>
	            <button type="submit" :disabled="loggingIn" class="purple" @click.prevent="login">
	                <span v-if="!loggingIn">{{ $t('button.label.login') }}</span>
	                <span v-if="loggingIn">{{ $t('button.label.logging-in') }}</span>
	            </button>
	            <br>
	            <a href="#" v-on:click="logout">{{ $t('login.remain-logged-out.button') }}</a>
	        </div>
	    </modal>
	</div>
</template>

<script>

	import {mapGetters} from 'vuex';
	import Modal from '../components/Modal'

	export default {
		computed: {
			...mapGetters([
				'getAccountEmail'
			])
		},
		components: {
            Modal
		},
		data: () => ({
			loggingIn: false,
			email: '',
			password: '',
			showErrors: []
		}),
		methods: {
			login() {
                this.loggingIn = true;
                axios({
                	method: 'POST',
                	url: window.config.apiUrl + 'api/login',
                	data: {
                		email: this.email,
                		password: this.password
                	}
                }).then(response => {
					this.loggingIn = false;
	                this.$store.dispatch('login', response.data);
	                this.$store.commit('setEmail', this.email);
					window.AuthorizationCancelSource = axios.CancelToken.source()
				}).catch(e => {
                	this.loggingIn = false;
                	if (typeof e.response.data.message == 'string') {
                		this.showErrors.push(e.response.data.message);
                	} else {
	                	for (var i in e.response.data.message) {
							this.showErrors.push(e.response.data.message[i]);
	                		break;
	                	}
	                }
                });
			},
			logout() {
				this.$store.dispatch('logout');
				this.$router.push('/login');
			},
			show() {
				this.email = this.getAccountEmail;
				document.getElementById('global-login-form').style.display = 'block';
			},
			hide() {
				document.getElementById('global-login-form').style.display = 'none';
			}
		}
	}
</script>
